module.exports = __webpack_public_path__ + "img/profile.40e513bb.jpg";